import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getAllocatedMsisdns = async (token, options = {}) => {
    log("welcome in getAllocatedMsisdns")

    if (!token || token === "") {
        alert("No token in getAllocatedMsisdns")
        return {error: true, message: "No token provided", msisdns: [], total: 0}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/get_allocated_msisdns_api'
        log("url=" + url)

        // Build query params
        const params = {}

        // Status filters - API expects status_active, status_expired, etc.
        if (options.status_all) {
            params.status_all = true
            if (options.exclude_terminated) params.exclude_terminated = true
        } else if (options.statuses && options.statuses.length > 0) {
            if (options.statuses.includes('active')) params.status_active = true
            if (options.statuses.includes('pending_payment')) params.status_pending_payment = true
            if (options.statuses.includes('expired')) params.status_expired = true
            if (options.statuses.includes('suspended')) params.status_suspended = true
            if (options.statuses.includes('terminated')) params.status_terminated = true
            if (options.statuses.includes('refunded')) params.status_refunded = true
            if (options.statuses.includes('available')) params.status_available = true
        }

        if (options.msisdn_class_id) {
            params.msisdn_class_id = options.msisdn_class_id
        }
        if (options.msisdn_group_id) {
            params.msisdn_group_id = options.msisdn_group_id
        }
        if (options.msisdn_like) {
            params.msisdn_like = options.msisdn_like
        }
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }
        if (options.client_id) {
            params.client_id = options.client_id
        }
        if (options.sort_by) {
            params.sort_by = options.sort_by
        }
        if (options.sort_direction) {
            params.sort_order = options.sort_direction
        }
        if (options.page) {
            params.page = options.page
        }
        if (options.per_page) {
            params.per_page = options.per_page
        }
        if (options.network_id) {
            params.network_id = options.network_id
        }

        log("getAllocatedMsisdns params being sent:")
        log(params)
        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getAllocatedMsisdns")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getAllocatedMsisdns")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getAllocatedMsisdns", msisdns: [], total: 0}
    }
}

export const getMsisdnDetails = async (token, sim_id, msisdn_id = null) => {
    log("welcome in getMsisdnDetails for sim_id=" + sim_id + ", msisdn_id=" + msisdn_id)

    if (!token || token === "") {
        alert("No token in getMsisdnDetails")
        return {error: true, message: "No token provided", msisdn_details: null}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_msisdn_details_api'
        log("url=" + url)

        const params = {}
        if (sim_id) params.sim_id = sim_id
        if (msisdn_id) params.msisdn_id = msisdn_id
        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getMsisdnDetails")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getMsisdnDetails")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMsisdnDetails", msisdn_details: null}
    }
}

export const getMsisdnAutocomplete = async (token, msisdn_like) => {
    log("welcome in getMsisdnAutocomplete for msisdn_like=" + msisdn_like)

    if (!token || token === "") {
        return {error: true, message: "No token provided", suggestions: [], has_more: false}
    }

    if (!msisdn_like || msisdn_like.length < 3) {
        return {error: false, suggestions: [], has_more: false}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_msisdn_autocomplete_api'
        log("url=" + url)

        const params = {msisdn_like: msisdn_like}
        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getMsisdnAutocomplete")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getMsisdnAutocomplete")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMsisdnAutocomplete", suggestions: [], has_more: false}
    }
}

export const deleteClientService = async (token, client_service_id) => {
    log("welcome in deleteClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios deleteClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteClientService"}
    }
}

export const terminateClientService = async (token, client_service_id) => {
    log("welcome in terminateClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/terminate_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios terminateClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in terminateClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la terminateClientService"}
    }
}

export const reactivateClientService = async (token, client_service_id) => {
    log("welcome in reactivateClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/reactivate_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios reactivateClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in reactivateClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la reactivateClientService"}
    }
}

export const suspendClientService = async (token, client_service_id) => {
    log("welcome in suspendClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/suspend_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios suspendClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in suspendClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la suspendClientService"}
    }
}

export const refundClientService = async (token, client_service_id) => {
    log("welcome in refundClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/refund_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios refundClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in refundClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la refundClientService"}
    }
}

export const renewClientService = async (token, client_service_id) => {
    log("welcome in renewClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/renew_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios renewClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in renewClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la renewClientService"}
    }
}

export const extendClientService = async (token, client_service_id) => {
    log("welcome in extendClientService for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/extend_client_service_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios extendClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in extendClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la extendClientService"}
    }
}

export const toggleAutorenew = async (token, client_service_id) => {
    log("welcome in toggleAutorenew for client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/toggle_autorenew_api'
        log("url=" + url)

        const result = await axios.post(url, {client_service_id: client_service_id}, {headers: headers})
        log("result.data din axios toggleAutorenew")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in toggleAutorenew")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la toggleAutorenew"}
    }
}

export const getSimBySearch = async (token, searchTerm, options = {}) => {
    log("welcome in getSimBySearch for searchTerm=" + searchTerm)

    if (!token || token === "") {
        return {error: true, message: "No token provided", found: false}
    }

    if (!searchTerm || searchTerm.length < 3) {
        return {error: false, found: false, message: "Search term must be at least 3 characters"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_sim_by_search_api'
        log("url=" + url)

        const params = {search_term: searchTerm}

        // Add status filter if provided
        if (options.status_ids && options.status_ids.length > 0) {
            params['status_ids[]'] = options.status_ids
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getSimBySearch")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSimBySearch")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getSimBySearch", found: false}
    }
}

export const getSimById = async (token, simId) => {
    log("welcome in getSimById for simId=" + simId)

    if (!token || token === "") {
        return {error: true, message: "No token provided", found: false}
    }

    if (!simId) {
        return {error: false, found: false, message: "No sim_id provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_sim_by_id_api'
        log("url=" + url)

        const params = {sim_id: simId}

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getSimById")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSimById")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getSimById", found: false}
    }
}

export const sendMsisdnInterestRequest = async (token, msisdn_id, message = '') => {
    log("welcome in sendMsisdnInterestRequest for msisdn_id=" + msisdn_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    if (!msisdn_id) {
        return {error: true, message: "No msisdn_id provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/send_msisdn_interest_request_api'
        log("url=" + url)

        const result = await axios.post(url, {
            msisdn_id: msisdn_id,
            message: message
        }, {headers: headers})
        log("result.data din axios sendMsisdnInterestRequest")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in sendMsisdnInterestRequest")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la sendMsisdnInterestRequest"}
    }
}

const useGetAllocatedMsisdnsAPI = () => {
    return {error, getAllocatedMsisdns, getMsisdnDetails, getMsisdnAutocomplete, deleteClientService, terminateClientService, reactivateClientService, suspendClientService, renewClientService, toggleAutorenew, getSimBySearch, sendMsisdnInterestRequest}
}

export default useGetAllocatedMsisdnsAPI
